export const analyticsTags = (data: Record<string, string>): Record<string, string> => {
  return Object.keys(data).reduce<Record<string, string>>((acc, key) => {
    acc[`data-analytics-${key}`] = data[key];
    return acc;
  }, {});
};
